import { Alert, AlertColor, Button } from "@rebootui";
import { FC, useState } from "react";
import { createPortal } from "react-dom";
import Icon from "../common/Icon";


type CopyCodeButtonProps = {
    toCopy: string
}

type AlertState = {
    message: string;
    color: AlertColor;
} | null;

const CopyCode: FC<CopyCodeButtonProps> = ({ toCopy }) => {
    const [alert, setAlert] = useState<AlertState>(null);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(toCopy);
            setAlert({ message: "Copied successfully!", color: AlertColor.Success });
            setTimeout(() => setAlert(null), 1000); // remove after 1s
        } catch (err) {
            setAlert({ message: String(err), color: AlertColor.Danger });
            setTimeout(() => setAlert(null), 1000); // remove after 1s
        }
    };

    return (
        <>
            <Button className="bg-transparent" onClick={handleCopy}>
                <Icon name="copy" width={24} height={24} />
            </Button>

            {alert &&
                typeof document !== "undefined" &&
                createPortal(
                    <Alert
                        color={alert.color}
                        className="position-fixed start-50 translate-middle-x mt-2 shadow-sm"
                        style={{ zIndex: 1080, top: 80 }}
                    >
                        <p className="m-0">{alert.message}</p>
                    </Alert>,
                    document.body
                )}
        </>
    )
}

export default CopyCode;
